import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import { Lightbulb } from "@faire/web--source/slate/icons/foundation/Lightbulb";
import React from "react";

import { SelfServeNode } from "../types";

export const DEFAULT_OTHER_NODE = (
  strictLocalize: StrictLocalizeFunction
): SelfServeNode => ({
  id: "DefaultOther",
  label: OTHER_NODES_LABEL(strictLocalize),
  level: 3,
  sidebarTitle: strictLocalize({
    defaultMessage: "Other issue",
    description: {
      text: "Title for displaying the issue on the order summary sidebar",
    },
  }),
  icon: <Lightbulb fontSize="24px" color="faireBlack" />,
});

export const OTHER_NODES_LABEL = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Other",
    description: {
      text: "A default issue node in the full page self-serve experience of Faire's Help Center",
    },
  });
